import { render, staticRenderFns } from "./CardProductbigV2.vue?vue&type=template&id=466dca1a&scoped=true&"
import script from "./CardProductbigV2.vue?vue&type=script&lang=js&"
export * from "./CardProductbigV2.vue?vue&type=script&lang=js&"
import style0 from "./CardProductbigV2.vue?vue&type=style&index=0&id=466dca1a&lang=scss&scoped=true&"
import style1 from "./CardProductbigV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466dca1a",
  null
  
)

export default component.exports